export enum OnCallPeriod {
    MorningAndAfternoon = 'MorningAndAfternoon',
    Morning = 'Morning',
    Afternoon = 'Afternoon'
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/onCallPeriod.ts